import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ViewCell } from '../ofbiz-form-model';
import { Cell } from 'angular2-smart-table';

@Component({
  template: `
    <div class="hyperlink" (click)="emit($event)">
      <span>
        <img src="assets/images/icons/outline/link-2-outline.svg" class="custom-icon">
      </span>
    {{renderValue}}
    </div>
  `,
})
export class OfbizCellInternalLinkComponent implements  ViewCell, OnInit {
  renderValue: string;
  @Input() cell:Cell;
  @Input() field:any;
  @Input() value: string | number;
  @Input() rowData: any;
  @Output() cellHyperlinkSelected = new EventEmitter(); 

  constructor() { }

  ngOnInit(): void {
    this.rowData = this.cell.getRow().getData();
    this.value = this.cell.getValue();
    console.log(this.field,this.rowData);
    this.renderValue = this.value.toString();
  }

  emit(e){
    this.cellHyperlinkSelected.emit(this.rowData);
  }

}
